import type { RouteConfig } from 'vue-router';

export const cabinetRoutes: RouteConfig[] = [
  {
    path: 'investor/projects/:num([A-Fa-f0-9]{8}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{12})/:human?',
    alias: ['borrower/projects/:num([A-Fa-f0-9]{8}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{12})/:human?'],
    redirect: (to) => ({
      name: 'project-direct',
      params: to.params,
      query: to.query,
      hash: to.hash,
    }),
  },
  {
    path: 'borrower/apps/:num([A-Fa-f0-9]{8}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{12})?',
    redirect: '/cabinet/loan-app/:num',
  },
  {
    path: 'borrower/apps/new',
    redirect: '/cabinet/loan-app/new',
  },
];
